export const getFileExtension = (filename) => {
  return filename.split('.').pop().toLowerCase();
};

// Helper function to generate random permissions
export default function generateRandomPermissions(item, spaceId) {
  return {
    readable: true, // 100% chance of being readable
    writable: item.space_id === spaceId, // true if the file or folder was created in the current user's pace
  };
}
